import { render, staticRenderFns } from "./_user-profile.vue?vue&type=template&id=b4639c28&scoped=true&"
import script from "./_user-profile.vue?vue&type=script&lang=js&"
export * from "./_user-profile.vue?vue&type=script&lang=js&"
import style0 from "./_user-profile.vue?vue&type=style&index=0&id=b4639c28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4639c28",
  null
  
)

export default component.exports